export default __webpack_public_path__ + "static/media/003-nopets.8de68287.png";